<template>
  <div class="main">
    <!-- <section class="left-container">
        <p class="title">Kcar</p>
        <p class="title2" style="font-size: 18px; font-weight: 700; margin-top: 20px;">주문 수정내역</p>
        <p class="title2" style="margin-top: 40px;">주문 수정 / 실패 내역</p>
    </section> -->
    <section class="main-contents">
      <div
        class="user-info bottom-line section-width"
        style="display: flex; justify-content: space-between;"
      >
        <b
          :class="{ redEffect: isActive1 }"
          id="redEffect"
          style="font-size: 1.2rem"
          >탁송 모니터링
          <el-tooltip
            class="item"
            effect="dark"
            content="알림 전체 삭제"
            placement="right"
          >
            <el-button
              @click="allClear()"
              style="margin-left: 10px;"
              type="danger"
              icon="el-icon-delete"
              circle
            ></el-button>
          </el-tooltip>
        </b>
        <div>
          <b style="padding-top: 2px;">{{ $store.getters.userAccount.name }}</b>
          님
          <el-button
            type="danger"
            plain
            style="margin-left: 10px;"
            @click="logout()"
            >로그아웃</el-button
          >
        </div>
      </div>
      <div class="table-option bottom-line section-width">
        <!-- <h4 style="margin-bottom: 15px;">주문 수정 내역</h4> -->
        <div class="date padding">
          <span style="margin-right: 5px;">조회 기간</span>
          <el-date-picker
            type="date"
            v-model="listQuery.fromDate"
            format="yyyy-MM-dd - 07:00"
            value-format="yyyy-MM-dd 07:00:00"
            placeholder="시작일"
          />
          <span style="margin: 0 5px;">~</span>
          <el-date-picker
            style="margin-right: 10px"
            type="date"
            v-model="listQuery.toDate"
            format="yyyy-MM-dd - 07:00"
            value-format="yyyy-MM-dd 07:00:00"
            placeholder="종료일"
          />
          <el-button type="info" @click="nowWeek()">금주</el-button>
          <el-button type="info" @click="yesterday()">어제</el-button>
          <el-button type="info" @click="toDay()">오늘</el-button>
          <!-- <el-button @click="dateCheck()">날짜 확인</el-button> -->
        </div>
        <div class="option-tab">
          <div class="corp-select padding" style="display:flex; gap: 30px;">
            <div style="display: flex; gap: 5px;">
              <span class="none-margin1" style="margin-right: 5px;"
                ><b>지사 선택</b></span
              >
              <el-button @click="vendorDrawerVisible = true"
                >지사선택</el-button
              >
            </div>
            <el-dialog
              title="I am the title"
              :visible.sync="vendorDrawerVisible"
            >
              <span>Hi there!</span>
            </el-dialog>

            <div>
              선택된 지사
            </div>
          </div>
          <div class="corp-select padding" style="display:flex">
            <span
              style="padding-top: 3px; margin-left: 30px; margin-right: 5px;"
              >상태</span
            >
            <el-select style="width: 8vw" v-model="stateId">
              <el-option
                v-for="item in stateList"
                :key="item.key"
                :label="item.value"
                :value="item.key"
              >
              </el-option>
            </el-select>
            <span
              style="padding-top: 3px; margin-left: 30px; margin-right: 5px;"
              >검색</span
            >
            <el-select
              style="margin-right:5px; width: 8vw;"
              placeholder="검색 조건"
              v-model="keywordId"
            >
              <el-option
                v-for="item in keywordType"
                :key="item.key"
                :label="item.value"
                :value="item.key"
              >
              </el-option>
            </el-select>
            <el-input
              style="margin-right: 5px; width: 20vw"
              v-model="listQuery.keyword"
              @keypress.enter.native="handleSearch"
            ></el-input>
            <el-button
              type="primary"
              icon="el-icon-search"
              @click="handleSearch()"
              v-loading.fullscreen.lock="searchLoading"
              element-loading-text="검색 진행중..."
              >검색</el-button
            >
          </div>
        </div>

        <!-- <div class="state-select padding"></div> -->
        <!-- <div class="search-input padding">
          <span style="margin-right: 55px;">검색</span>
          <el-select placeholder="검색 조건" v-model="keywordId">
            <el-option
              v-for="item in keywordType"
              :key="item.key"
              :label="item.value"
              :value="item.key"
            >
            </el-option>
          </el-select>
          <el-input
            style="width: 12vw"
            v-model="listQuery.keyword"
            @keypress.enter.native="handleSearch"
          ></el-input>
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="handleSearch()"
            v-loading.fullscreen.lock="searchLoading"
            element-loading-text="검색 진행중..."
            >검색</el-button
          >
        </div> -->
      </div>
      <div style="padding: 10px" class="bottom-line">
        <b style="margin-right: 5px;">자동 새로고침</b>
        <el-switch
          v-model="onload"
          active-text="on"
          inactive-text="off"
          active-color="#13ce66"
          inactive-color="#ff4949"
          active-value="100"
          inactive-value="0"
        >
        </el-switch>
        <span style="margin-bottom: 10px; margin-left: 50px;"
          ><b>총 {{ total }} 건</b>
          <el-button
            style="margin-left: 50px;"
            type="primary"
            @click="ExcelDownload()"
            :disabled="ExcelButton"
            v-loading.fullscreen.lock="ExcelLoading"
            element-loading-text="엑셀 다운로드 진행중..."
            >엑셀 다운로드</el-button
          >
        </span>
      </div>
      <div class="table section-width">
        <el-table
          border
          v-loading.fullscreen.lock="loading"
          element-loading-text="리스트 불러오는 중..."
          :data="payload"
          id="list-table"
          class="table"
          style="width:99%; margin-top: 20px;"
        >
          <el-table-column
            align="center"
            prop="orderNo"
            label="번호"
            width="50"
            type="index"
          >
            <!-- <template slot-scope="scope">
                        <div class="orderNo">

                        </div>
                    </template> -->
          </el-table-column>
          <el-table-column
            align="center"
            prop="vendorName"
            label="지사명"
            width="80"
          >
            <template slot-scope="scope">
              <div class="vendorName" v-if="scope.row.vendorName !== null">
                {{ scope.row.vendorName }}
              </div>
              <div class="vendorName" v-else>
                -
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" width="160" label="상황실">
            <template slot-scope="scope">
              <div class="confirmState" v-if="scope.row.confirmState === 1">
                <span class="confirmState"
                  ><b>{{ scope.row.managerName }}</b></span
                >
                <br />
                <span class="confirmDate">
                  {{
                    (scope.row.confirmDate.substring(0, 10) || "").split(
                      "."
                    )[0]
                  }}<br />
                  {{
                    (scope.row.confirmDate.substring(10, 20) || "").split(
                      "."
                    )[0]
                  }}
                </span>
              </div>
              <div
                class="confirmState"
                v-if="
                  scope.row.confirmState === 2 || scope.row.confirmState === 0
                "
              >
                <el-form>
                  <el-input
                    type="text"
                    style="width: 100%; border-color: red; text-align: center;"
                    v-model="$store.getters.userAccount.name"
                    disabled
                  />
                  <div class="button-list">
                    <el-tooltip
                      class="item"
                      effect="dark"
                      :content="
                        tooltipLabelOption(scope.row.actionButtons, 'confirm')
                      "
                      placement="bottom-start"
                      :disabled="
                        actionActive(scope.row.actionButtons, 'confirm')
                      "
                    >
                      <el-button
                        :type="
                          actionActive(scope.row.actionButtons, 'confirm') ===
                          false
                            ? 'success'
                            : 'info'
                        "
                        circle
                        @click="updateOrderState(scope.row, 'action_confirm')"
                        :disabled="
                          actionActive(scope.row.actionButtons, 'confirm')
                        "
                        ><i class="el-icon-check"></i
                      ></el-button>
                    </el-tooltip>
                    <el-tooltip
                      class="item"
                      effect="dark"
                      :content="
                        tooltipLabelOption(scope.row.actionButtons, 'apply')
                      "
                      placement="bottom-start"
                      :disabled="actionActive(scope.row.actionButtons, 'apply')"
                    >
                      <el-button
                        :type="
                          actionActive(scope.row.actionButtons, 'apply') ===
                          false
                            ? 'primary'
                            : 'info'
                        "
                        circle
                        @click="updateOrderState(scope.row, 'action_apply')"
                        :disabled="
                          actionActive(scope.row.actionButtons, 'apply')
                        "
                        ><i class="el-icon-edit"></i
                      ></el-button>
                    </el-tooltip>
                    <el-tooltip
                      class="item"
                      effect="dark"
                      :content="
                        tooltipLabelOption(scope.row.actionButtons, 'relink')
                      "
                      placement="bottom-start"
                      :disabled="
                        actionActive(scope.row.actionButtons, 'relink')
                      "
                    >
                      <el-button
                        :type="
                          actionActive(scope.row.actionButtons, 'relink') ===
                          false
                            ? 'danger'
                            : 'info'
                        "
                        circle
                        @click="updateOrderState(scope.row, 'action_relink')"
                        :disabled="
                          actionActive(scope.row.actionButtons, 'relink')
                        "
                        ><i class="el-icon-refresh"></i
                      ></el-button>
                    </el-tooltip>
                  </div>

                  <!-- <el-button
                    v-if="
                      scope.row.orderApplyState === 2 && scope.row.reqType !== 3
                    "
                    @click="reOrder(scope.row)"
                    style="width: 100%; margin-top: 10px;"
                    type="danger"
                    plain
                    >재연동</el-button
                  >
                  <el-button
                    v-else
                    @click="updateOrder(scope.row, changeText(scope.row))"
                    style="width: 100%; margin-top: 10px;"
                    type="primary"
                    plain
                    >{{ changeText(scope.row) }}</el-button
                  > -->
                </el-form>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="orderApplyState"
            label="Star-T 반영"
            width="100"
          >
            <template slot-scope="scope">
              <div class="orderApplyState">
                <b>{{ scope.row.orderApplyState | orderApplyStateRename }}</b
                ><br />
                <p v-show="scope.row.orderApplyState === 2">
                  {{ scope.row.orderApplyStateMsg }}
                </p>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="reqDate"
            label="수정 시간"
            width="120"
          >
            <template slot-scope="scope">
              <div class="reqDate" v-if="scope.row.reqDate !== null">
                {{ (scope.row.reqDate.substring(0, 10) || "").split(".")[0]
                }}<br />
                {{ (scope.row.reqDate.substring(10, 20) || "").split(".")[0] }}
              </div>
              <div class="reqDate" v-else>
                -
              </div>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="reqType"
            label="요청 구분"
            width="80"
          >
            <template slot-scope="scope">
              <div class="reqType">
                <b>{{ scope.row.reqTypeName }}</b>
              </div>
            </template>
          </el-table-column>

          <!-- <el-table-column align="center" prop="confirmDate" label="주문 확인 시간" width="150" /> -->
          <el-table-column
            align="center"
            prop="confirmDate"
            label="주문 확인 시간"
            width="85"
          >
            <template slot-scope="scope">
              <div class="confirmDate" v-if="scope.row.confirmDate !== null">
                {{ (scope.row.confirmDate.substring(0, 10) || "").split(".")[0]
                }}<br />
                {{
                  (scope.row.confirmDate.substring(10, 20) || "").split(".")[0]
                }}
              </div>
              <div class="confirmDate" v-else>
                -
              </div>
            </template>
          </el-table-column>
          <el-table-column
            align="left"
            prop="transNo"
            label="탁송 연동 번호"
            width="130"
          >
            <template slot-scope="scope">
              <div class="transNo">
                연동:
                <span v-if="scope.row.transNo !== null">{{
                  scope.row.transNo
                }}</span>
                <span v-else>-</span>
              </div>
              <div class="orderNo">
                오더:
                <span v-if="scope.row.orderNo !== null">{{
                  scope.row.orderNo
                }}</span>
                <span v-else>-</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="serviceTypeName"
            label="탁송구분"
            width="100"
          >
            <template slot-scope="scope">
              <div
                class="serviceTypeName"
                v-if="scope.row.serviceTypeName !== null"
              >
                <div v-if="scope.row.serviceTypeName.replace(' ', '') !== '[]'">
                  <span>{{ scope.row.serviceTypeName }}</span>
                </div>
                <div v-else>
                  -
                </div>
              </div>
              <div class="serviceTypeName" v-else>
                -
              </div>
            </template>
          </el-table-column>
          <el-table-column
            align="left"
            prop="user.name"
            label="신청사원 전화번호"
            width="150"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.user !== null">
                신청자:
                <span
                  v-if="scope.row.user.name !== null"
                  class="user user_name"
                  >{{ scope.row.user.name }}</span
                ><br />
                전화:
                <span
                  v-if="scope.row.user.phoneNumber !== null"
                  class="user user_phoneNo"
                  >{{ scope.row.user.phoneNo | phoneNumber }}</span
                >
              </div>
              <div class="user user_name" v-else>
                -
              </div>
            </template>
          </el-table-column>
          <!-- <el-table-column align="center" prop="user.phoneNo" label="신청자 전화번호" width="120">
                    <template slot-scope="scope">
                        <div v-if="scope.row.user !== null">
                            <span class="user user_phoneNo">{{ scope.row.user.phoneNo | phoneNumber }}</span>
                        </div>
                        <div class="user user_phoneNo" v-else>
                            -
                        </div>
                    </template>
                </el-table-column>
                 -->
          <el-table-column
            align="left"
            prop="car"
            label="차량번호 및 모델명"
            width="130"
          >
            <template slot-scope="scope">
              <div>
                번호:
                <span
                  v-if="scope.row.car !== null && scope.row.car.carNo !== null"
                  class="car car_carNo"
                  >{{ scope.row.car.carNo }}</span
                ><span v-else>-</span>
              </div>
              <div>
                브랜드:
                <span
                  v-if="scope.row.car !== null && scope.row.car.brand !== null"
                  class="car car_brand"
                  >{{ scope.row.car.brand }}</span
                ><span v-else>-</span>
              </div>
              <div>
                모델:
                <span
                  v-if="
                    scope.row.car !== null &&
                      scope.row.car.vehicleModel !== null
                  "
                  class="car car_vehicleModel"
                  >{{ scope.row.car.vehicleModel }}</span
                ><span v-else>-</span>
              </div>
            </template>
          </el-table-column>
          <!-- <el-table-column align="center" prop="reservationDate" label="예약일자" width="100"/> -->
          <el-table-column
            align="center"
            prop="reservationDate"
            label="예약일자"
            width="90"
          >
            <template slot-scope="scope">
              <div
                class="reservationDate"
                v-if="scope.row.reservationDate !== null"
              >
                {{
                  (scope.row.reservationDate.substring(0, 10) || "").split(
                    "."
                  )[0]
                }}<br />
                {{
                  (scope.row.reservationDate.substring(10, 20) || "").split(
                    "."
                  )[0]
                }}
              </div>
              <div class="reservationDate" v-else>
                -
              </div>
            </template>
          </el-table-column>
          <el-table-column
            align="left"
            prop="start"
            label="출발지, 도착지, 경유지"
            width="440"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.start !== null">
                출:
                <span class="start start start_addr">{{
                  scope.row.start.addr
                }}</span>
                ;
                <span class="start start_locationName">{{
                  scope.row.start.locationName
                }}</span>
                ;
                <span class="start start_phoneNo">{{
                  scope.row.start.phoneNo | phoneNumber
                }}</span>
              </div>
              <div v-if="scope.row.end !== null">
                도: <span class="end end_addr">{{ scope.row.end.addr }}</span> ;
                <span class="end end_locationName">{{
                  scope.row.end.locationName
                }}</span>
                ;
                <span class="end end_phoneNo">{{
                  scope.row.end.phoneNo | phoneNumber
                }}</span>
              </div>
              <div v-if="scope.row.via1 !== null">
                경1:
                <span class="via1 via1_addr">{{ scope.row.via1.addr }}</span> ;
                <span class="via1 via1_locationName">{{
                  scope.row.via1.locationName
                }}</span>
                ;
                <span class="via1 via1_phoneNo">{{
                  scope.row.via1.phoneNo | phoneNumber
                }}</span>
              </div>
              <div v-if="scope.row.via2 !== null">
                경2:
                <span class="via2 via2_addr">{{ scope.row.via2.addr }}</span> ;
                <span class="via2 via2_locationName">{{
                  scope.row.via2.locationName
                }}</span>
                ;
                <span class="via2 via2_phoneNo">{{
                  scope.row.via2.phoneNo | phoneNumber
                }}</span>
              </div>
              <div v-if="scope.row.via3 !== null">
                경3:
                <span class="via3 via3_addr">{{ scope.row.via3.addr }}</span> ;
                <span class="via3 via3_locationName">{{
                  scope.row.via3.locationName
                }}</span>
                ;
                <span class="via3 via3_phoneNo">{{
                  scope.row.via3.phoneNo | phoneNumber
                }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="memo"
            label="탁송기사 요청사항"
            width="140"
          >
            <template slot-scope="scope">
              <div class="memo" v-if="scope.row.memo !== null">
                {{ scope.row.memo }}
              </div>
              <div class="memo" v-else>
                -
              </div>
            </template>
          </el-table-column>
          <el-table-column
            align="left"
            prop="custCostYn"
            label="고객 비용 부담여부"
            width="85"
          >
            <template slot-scope="scope">
              <div>
                탁송:
                <span class="custCostYn" v-if="scope.row.custCostYn !== null">{{
                  scope.row.custCostYn
                }}</span
                ><span class="custCostYn" v-else>-</span>
              </div>
              <div>
                주유:
                <span class="custFuelYn" v-if="scope.row.custFuelYn !== null">{{
                  scope.row.custFuelYn
                }}</span
                ><span class="custFuelYn" v-else>-</span>
              </div>
              <div>
                추가주유:
                <span
                  class="addtGasRqstAmt"
                  v-if="scope.row.addtGasRqstAmt !== null"
                  >{{ scope.row.addtGasRqstAmt | comma }}</span
                ><span class="addtGasRqstAmt" v-else>-</span>
              </div>
              <div>
                고객지불:
                <span
                  class="customerPayAmount"
                  v-if="scope.row.customerPayAmount !== null"
                  >{{ scope.row.customerPayAmount | comma }}</span
                ><span class="customerPayAmount" v-else>-</span>
              </div>
            </template>
          </el-table-column>
          <!-- <el-table-column align="center" prop="custFuelYn" label="주유비 고객부탐여부" width="90">
                    <template slot-scope="scope">
                        <div class="custFuelYn" v-if="scope.row.custFuelYn !== null">
                            {{ scope.row.custFuelYn }}
                        </div>

                        <div class="custFuelYn" v-else>
                            -
                        </div>
                    </template>
                </el-table-column>

                <el-table-column align="center" prop="addtGasRqstAmt" label="추가주유요청" width="100">
                    <template slot-scope="scope">
                        <div class="addtGasRqstAmt" v-if="scope.row.addtGasRqstAmt !== null">
                            {{ scope.row.addtGasRqstAmt | comma }}
                        </div>

                        <div class="addtGasRqstAmt" v-else>
                            -
                        </div>
                    </template>
                </el-table-column> -->
          <el-table-column label="기타" width="150">
            <template slot-scope="scope">
              <div>
                왕복 :<span class="roundTrip"> {{ scope.row.roundTrip }}</span
                ><br />
                유형 :<span class="assignTypeName">
                  {{ scope.row.assignTypeName }}</span
                ><br />
                가격 :<span class="systemPrice">
                  {{ scope.row.systemPrice | comma }}</span
                >{{ " "
                }}<span class="distance">({{ scope.row.distance }} km)</span
                ><br />
              </div>
            </template>
          </el-table-column>
        </el-table>

        <pagination
          v-show="total > 0"
          :total="searchTotal"
          :page.sync="listQuery.currentPage"
          :limit.sync="listQuery.perPageCount"
          @pagination="fetchData"
        />
      </div>
    </section>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import Pagination from "../components/Pagination";
import moment from "moment";
import store from "@/store";
import employeeApi from "../api/employee";
import { dateFormatter } from "@/utils/formatter/date";
import XLSX from "xlsx";

export default {
  components: {
    Pagination
  },
  filters: {
    phoneNumber: function(phoneNumber) {
      if (!phoneNumber) return phoneNumber;
      phoneNumber = phoneNumber.replace(/[^0-9]/g, "");
      let tmp = "";
      if (phoneNumber.length < 4) {
        // return phoneNumber;
      } else if (phoneNumber.length < 7) {
        tmp += phoneNumber.substr(0, 3);
        tmp += "-";
        tmp += phoneNumber.substr(3);
        // return tmp;
      } else if (phoneNumber.length === 8) {
        tmp += phoneNumber.substr(0, 4);
        tmp += "-";
        tmp += phoneNumber.substr(4);
        // return tmp;
      } else if (phoneNumber.length < 10) {
        if (phoneNumber.substr(0, 2) === "02") {
          tmp += phoneNumber.substr(0, 2);
          tmp += "-";
          tmp += phoneNumber.substr(2, 3);
          tmp += "-";
          tmp += phoneNumber.substr(5);
          // return tmp;
        }
      } else if (phoneNumber.length < 11) {
        if (phoneNumber.substr(0, 2) === "02") {
          tmp += phoneNumber.substr(0, 2);
          tmp += "-";
          tmp += phoneNumber.substr(2, 4);
          tmp += "-";
          tmp += phoneNumber.substr(6);
          // return tmp;
        } else {
          tmp += phoneNumber.substr(0, 3);
          tmp += "-";
          tmp += phoneNumber.substr(3, 3);
          tmp += "-";
          tmp += phoneNumber.substr(6);
          // return tmp;
        }
      } else {
        tmp += phoneNumber.substr(0, 3);
        tmp += "-";
        tmp += phoneNumber.substr(3, 4);
        tmp += "-";
        tmp += phoneNumber.substr(7);
        return tmp;
      }
      return phoneNumber;
    },
    reqTypeRename: function(row) {
      const reqType = [
        { key: 1, value: "주문접수" },
        { key: 2, value: "주문수정" },
        { key: 3, value: "주문취소" }
      ];
      const findType = _.find(reqType, d => {
        return d.key === row;
      });
      let reqTypeName = "";
      if (findType === false || typeof findType === "undefined") {
        reqTypeName = reqType[0].value;
      } else {
        reqTypeName = findType.value;
      }
      return reqTypeName;
    },
    orderApplyStateRename: function(row) {
      const orderApplyStateType = [
        { key: -1, value: "-" },
        { key: 0, value: "-" },
        { key: 1, value: "성공" },
        { key: 2, value: "실패" },
        { key: 3, value: "재연동 성공" }
      ];
      const findType = _.find(orderApplyStateType, d => {
        return d.key === row;
      });
      let orderApply = "";
      if (findType === false || typeof findType === "undefined") {
        orderApply = orderApplyStateType[0].value;
      } else {
        orderApply = findType.value;
      }
      return orderApply;
    },
    comma(val) {
      return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  },
  data() {
    return {
      vendorDrawerVisible: false,
      confirmButton: false,
      relinkButton: false,
      applyButton: false,
      isActive1: false,
      isActive2: false,
      loading: false,
      searchLoading: false,
      ExcelButton: false,
      ExcelLoading: false,
      onload: true,
      //   vendorId: 0,
      selectVendorList: [],
      corpId: 0,
      deptId: 0,
      stateId: 0,
      keywordId: 0,
      listQuery: {
        currentPage: 0,
        perPageCount: 10,
        fromDate: dateFormatter(new Date()),
        toDate: dateFormatter(new Date()),
        keyword: "",
        state: 0,
        dateType: 1 // 1: 접수일자, 2: 예약일자
      },
      // listQuery: {
      //     fromDate: dateFormatter(this.calcDate(-7)),
      //     toDate: dateFormatter(new Date()),
      //     state: 0,
      //     currentPage: 1,
      //     currentPageGroupIdx: 0,
      //     perPageCount: 10,
      // },
      vendorList: [],
      corpList: [],
      deptList: [],
      dummyDeptList: [{ deptNo: 0, deptName: "전체" }],
      dummyCorpList: [{ corpNo: 0, corpName: "전체" }],
      stateList: [
        { key: 0, value: "전체" },
        { key: 1, value: "주문 접수" },
        { key: 2, value: "주문 수정" },
        { key: 3, value: "주문 취소" }
      ],
      keywordType: [
        { key: 0, value: "전체" },
        { key: 1, value: "연동번호(탁송관리번호)" },
        { key: 2, value: "YW주문번호" },
        { key: 3, value: "차량번호" },
        { key: 4, value: "예약자" },
        { key: 5, value: "예약자 전화번호" },
        { key: 6, value: "법인명" },
        { key: 7, value: "부서명" }
      ],
      pid: {
        managerName: ""
      },
      payload: [],
      total: 0,
      totalOrders: null,
      totalOrdersPayload: {},
      test: true
    };
  },
  computed: {
    searchTotal() {
      return this.total;
    }
  },
  watch: {
    payload: function(newVal, oldVal) {
      console.log("newVal : ", newVal);
      console.log("oldVal : ", oldVal);
    },
    totalOrders: function(newVal, oldVal) {
      // console.log("새로운 값: ",newVal, "예전 값: ", oldVal)
      if (newVal !== oldVal && oldVal !== null) {
        this.isActive1 = true;
        this.$notify({
          title: "알림",
          message: `새로운 항목이 추가되었습니다! (오더번호: ${this.totalOrdersPayload.contents[0].orderNo})`,
          type: "warning",
          position: "top-right",
          duration: 0
        });
        document.querySelector(".el-icon-close").onclick = () => {
          this.isActive1 = false;
          return this.isActive1;
        };
        // if(this.totalOrdersPayload.contents[0].confirmState === 0 || this.totalOrdersPayload.contents[0].confirmState === 2) {

        // } else {
        //     this.isActive1 = false;
        //     return this.isActive1;
        // }
      }
    },
    onload: function(newVal, oldVla) {
      let interval = setInterval(() => {
        if (this.onload === "100") {
          // 100 : 활성화
          this.handleSearch();
        } else if (this.onload === "0") {
          clearInterval(interval); /// 0 : 비활성화
        }
      }, 30000); // 30초 간격으로 리스트 불러와줌
      return interval;
    },
    payload: function(newVal, oldVal) {
      // this.$nextTick(() => {
      //     const thead = document.querySelectorAll('td');
      //     // console.log(thead)
      //     // thead.style.color = "#fff"
      // })
      // this.$router.go();
      Object.keys(this.payload[0]).forEach(key => {
        if (key !== "changeFields") {
          // console.log(key)
          const dom = document.querySelectorAll(`.${key}`);
          $(".start").removeAttr("style");
          $(".user").removeAttr("style");
          $(".car").removeAttr("style");
          $(".end").removeAttr("style");
          $(".via1").removeAttr("style");
          $(".via2").removeAttr("style");
          $(".via3").removeAttr("style");
          $(".user").removeAttr("style");
          $(".transNo").removeAttr("style");
          $(".reservationDate").removeAttr("style");
          $(".roundTrip").removeAttr("style");
          $(".assignTypeName").removeAttr("style");
          $(".systemPrice").removeAttr("style");
          $(".distance").removeAttr("style");
          $(".memo").removeAttr("style");
          $(".custCostYn").removeAttr("style");
          $(".custFuelYn").removeAttr("style");
          $(".addtGasRqstAmt").removeAttr("style");
          $(".reqType").removeAttr("style");
          $(".customerPayAmount").removeAttr("customerPayAmount");
          // if(dom && dom.length > 0) {
          //     // for(let i = 0; i > 20; i++) {
          //     //     console.log(dom[i]);
          //     //     dom[i].style.color = "#606266";
          //     // };
          //     // console.log(dom[6])
          //     dom[0].style.color = "#606266";
          //     dom[1].style.color = "#606266";
          //     dom[2].style.color = "#606266";
          //     dom[3].style.color = "#606266";
          //     dom[4].style.color = "#606266";
          //     dom[5].style.color = "#606266";
          //     dom[6].style.color = "#606266";
          //     dom[7].style.color = "#606266";
          //     dom[8].style.color = "#606266";
          //     dom[9].style.color = "#606266";
          //     // dom[0].removeAttr('style');
          //     // dom[1].removeAttr('style');
          //     // dom[2].removeAttr('style');
          //     // dom[3].removeAttr('style');
          //     // dom[4].removeAttr('style');
          //     // dom[5].removeAttr('style');
          //     // dom[6].removeAttr('style');
          //     // dom[7].removeAttr('style');
          //     // dom[8].removeAttr('style');
          //     // dom[9].removeAttr('style');

          // }
        }
      });
    }
  },
  setup() {},
  created() {},
  mounted() {
    // console.log(document.querySelectorAll(".temp").length)
    this.toDay();
    this.callVenderList();
    // this.callCorpList();
    this.fetchData();
  },
  unmounted() {},
  methods: {
    handleClose(done) {
      done();
    },
    // dateCheck() {
    //     console.log(this.listQuery.fromDate , this.listQuery.toDate)
    // },
    async updateOrderState(row, requestKey) {
      let dialogText = "";
      const requestBody = {
        pid: row.pid,
        orderNo: row.orderNo,
        managerName: this.$store.getters.userAccount.name,
        requestKey
      };
      if (requestKey === "action_confirm") {
        dialogText = "주문 확인을 하시겠습니까?";
      } else if (requestKey === "action_apply") {
        dialogText = "확인 & 적용을 하시겠습니까?";
      } else if (requestKey === "action_relink") {
        dialogText = "재연동 하시겠습니까?";
      } else {
        dialogText = "진행 하시겠습니까?";
      }
      this.$confirm(dialogText, "star-t", {
        confirmButtonText: "확인",
        cancelButtonText: "취소",
        type: "warning"
      })
        .then(() => {
          return employeeApi
            .updateModifiedState(requestBody)
            .then(res => {
              if (res.data.result === 0) {
                // 클립보드 복사 기능
                this.$copyText(String(row.orderNo))
                  .then(e => {
                    this.$message.success("주문번호 복사됨");
                  })
                  .catch(err => {
                    alert(err);
                  });
                this.handleSearch();
              } else {
                this.$message.error(res.data.message);
              }
            })
            .catch(err => {
              console.log(err);
            });
        })
        .catch(() => {});
    },
    tooltipLabelOption(data, buttonType) {
      let label = "";
      for (let i = 0; i < data.length; i++) {
        if (data[i].type === buttonType) {
          switch (buttonType) {
            case "confirm":
              label = data[i].label;
              break;
            case "apply":
              label = data[i].label;
              break;
            case "relink":
              label = data[i].label;
              break;
          }
        }
      }
      return label;
    },
    actionActive(data, buttonType) {
      let state = true;
      for (let i = 0; i < data.length; i++) {
        if (data[i].type === buttonType) {
          state = false;
        }
      }
      return state;
    },
    allClear() {
      // document.querySelectorAll('.el-icon-close').click();
      for (
        let i = 0;
        i < document.querySelectorAll(".el-icon-close").length;
        i++
      ) {
        document.querySelectorAll(".el-icon-close")[i].click();
      }
    },
    changeText(row) {
      // const changeFieldsArr = row.changeFields.split(",");
      // console.log(changeFieldsArr);
      if (row.changeFields === null) {
        return "주문확인";
      } else if (row.changeFields === "reservationDate") {
        return "확인 & 적용";
      } else {
        const changeFieldsArr = row.changeFields.split(",");
        let count = 0;
        for (let i = 0; i < changeFieldsArr.length; i++) {
          if (changeFieldsArr[i] === "reservationDate") {
            count = count + 1;
          }
        }
        if (count === 1) {
          return "확인 & 적용";
        } else {
          return "주문확인";
        }
      }
    },
    changeVendorList(item) {
      this.deptId = 0;
      this.corpId = 0;
      return employeeApi
        .corpList(item)
        .then(res => {
          // console.log(res.data.payLoad.corps);
          this.corpList = res.data.payLoad.corps;
          // console.log("vendor : ", this.vendorId, " corp : ", this.corpId, " dept : ", this.deptId)
        })
        .catch(err => {
          console.log(err);
        });
    },
    changeCorpList(item) {
      this.deptId = 0;
      return employeeApi
        .deptList(item)
        .then(res => {
          this.deptList = res.data.payLoad.depts;
        })
        .catch(err => {
          console.log(err);
        });
    },
    callVenderList() {
      const store = this.$store;
      this.vendorList = store.getters.userAccount.vendors.slice(1);
      // for (let i = 0; i < this.vendorList.length; i++) {
      //   this.selectVendorList.push(this.vendorList[i].vendorNo);
      // }

      // console.log(this.vendorList)
      // console.log(store.getters.userAccount);
    },
    ExcelDownload() {
      this.ExcelButton = true;
      this.ExcelLoading = true;
      // var wscols = [ // 컬럼 넓이 조정
      //   {wch:10}, // No.
      //   {wch:12}, // tranc no.
      //   {wch:25}, // 예약자
      //   {wch:25}, // 지점명
      //   {wch:20}, // 탁송일
      //   {wch:12}, // WIP 번호
      //   {wch:15}, // 고객명
      //   {wch:10}, // 차대번호
      //   {wch:15}, // 차량번호
      //   {wch:15}, // 모델명
      //   {wch:16},  // 서비스 유형
      //   {wch:13}, // 탁송업체
      //   {wch:18}, // 배차유형
      //   {wch:32}, // 출발지
      //   {wch:32}, // 도착지
      //   {wch:10}, // 거리
      //   {wch:10}, // 탁송료
      //   {wch:10}, // VAT
      //   {wch:10}, // 주유비
      //   {wch:10}, // 톨비
      //   {wch:10}, // 기타
      //   {wch:15}, // 합계금액
      //   {wch:20}, // 비고
      //   {wch:40}, // 메모
      //   // {wch:15}, // vat
      //   // {wch:15}, // 주유비
      //   // {wch:15}, // 톨비
      //   // {wch:15}, // 기타
      //   // {wch:15}, // 합계금액
      //   // {wch:40}, // 비고
      // ]
      // var excelData = XLSX.utils.json_to_sheet(this.payload); // this.payload = json 파일을 불러온 값
      // var workBook = XLSX.utils.book_new(); // 새 시트 생성
      // XLSX.utils.book_append_sheet(workBook, excelData, '정산 목록'); // 시트 명명, 데이터 지정
      // XLSX.writeFile(workBook, '정산목록.xlsx'); // 엑셀파일 만듬
      // var excelData = XLSX.utils.table_to_sheet(document.getElementById('excelDownload-table')); // table id를 넣어주면된다.
      // var excelData = XLSX.utils.json_to_sheet(this.payload); //json data 입력
      var excelData = XLSX.utils.table_to_sheet(
        document.getElementById("list-table"),
        { raw: true }
      );
      var workBook = XLSX.utils.book_new(); // 새 시트 생성
      // excelData['!cols'] = wscols; // 컬럼 각각의 넓이를 지정 해줌.
      // console.log(excelData);
      // console.log(workBook);
      XLSX.utils.book_append_sheet(workBook, excelData, "주문 수정 내역"); // 시트 명명, 데이터 지정
      XLSX.writeFile(workBook, "주문 수정 내역.xlsx"); // 엑셀파일 만듬
      setInterval(() => {
        this.ExcelLoading = false;
        this.ExcelButton = false;
      }, 3000);
    },
    nowWeek() {
      moment().day(7);
      moment().day(10);
      moment().day(24);

      const format = "yyyy-MM-DD 07:00:00";
      const monday = moment()
        .day(1)
        .format(format);
      const sunday = moment()
        .day(8)
        .format(format);
      // console.log("월요일 : " + moment().day(1).format(format));
      // console.log("일요일 : " + moment().day(7).format(format));
      return (
        (this.listQuery.fromDate = monday), (this.listQuery.toDate = sunday)
      );
    },
    toDay() {
      const format = "yyyy-MM-DD 07:00:00";
      const fromDate = moment()
        .subtract(0, "days")
        .format(format);
      const toDate = moment()
        .subtract(-1, "days")
        .format(format);
      return (
        (this.listQuery.fromDate = fromDate), (this.listQuery.toDate = toDate)
      );
    },
    yesterday() {
      // moment().subtract(12, 'days').format(format)
      const format = "yyyy-MM-DD 07:00:00";
      const yesterday = moment()
        .subtract(1, "days")
        .format(format);
      return (
        (this.listQuery.fromDate = yesterday),
        (this.listQuery.toDate = moment()
          .subtract(0, "days")
          .format("yyyy-MM-DD 07:00:00"))
      );
    },
    logout: function() {
      this.$store.dispatch("userAccount/logout").then(() => {
        this.$router.push("/login");
      });
    },
    calcDate(daysToAdd) {
      const date = new Date();
      date.setDate(date.getDate() + daysToAdd);
      return date;
    },
    handleSearch() {
      this.searchLoading = true;
      const requestBody = {
        pagePerCount: this.listQuery.perPageCount,
        currentPage:
          this.listQuery.currentPage === 0 ? 0 : this.listQuery.currentPage - 1,
        // currentPagePerCount: 0,
        fromDate: this.listQuery.fromDate,
        toDate: this.listQuery.toDate,
        reqType: this.stateId,
        dateType: 5,
        keywordType: this.keywordId,
        keyword: this.listQuery.keyword,
        vendorNos: this.selectVendorList
      };
      const testRequest = {
        pagePerCount: this.listQuery.perPageCount,
        currentPage:
          this.listQuery.currentPage === 0 ? 0 : this.listQuery.currentPage - 1,
        // currentPagePerCount: 0,
        fromDate: "2000-01-01 07:00:00",
        toDate: this.listQuery.toDate,
        reqType: 0,
        dateType: 5,
        keywordType: 0,
        keyword: "",
        vendorNos: this.selectVendorList
      };
      employeeApi.modifiedHistoryV2(testRequest).then(res => {
        this.totalOrders = res.data.payLoad.totalContentCnt;
        this.totalOrdersPayload = res.data.payLoad;
      });
      return employeeApi
        .modifiedHistoryV2(requestBody)
        .then(res => {
          const payLoad = res.data.payLoad;
          this.listQuery.currentPage =
            payLoad.totalContentCnt === 0 ? 1 : payLoad.currentPage + 1;
          this.total = payLoad.totalContentCnt;
          this.payload = payLoad.contents;
          this.searchLoading = false;
          this.$nextTick(() => {
            this.payload.forEach((content, contentIdx) => {
              if (content.changeFields) {
                Object.keys(content).forEach(key => {
                  content.changeFields.split(",").forEach(res => {
                    if (
                      key !== "changeFields" &&
                      res.split(".")[0] === key.split(".")[0]
                    ) {
                      // console.log(contentIdx, res);

                      // document.querySelectorAll(`.${re s}`)[contentIdx].style.color = "#eb2b2b"
                      // console.log("적용완료", document.querySelectorAll(`.${key}`))
                      const response = res.split(".");

                      let className = null;
                      if (response[1] !== undefined) {
                        className = key + "_" + response[1];
                      } else {
                        className = key;
                      }
                      // console.log(contentIdx ,className)
                      const dom = document.querySelectorAll(`.${className}`);
                      if (dom && dom.length > 0) {
                        dom[contentIdx].style.color = "#eb2b2b";
                      }
                    }
                    // console.log(content.changeFields.split(","))
                    // if(key !== "changeFields" && res === key.split(".")[0]) {
                    //     // console.log(content.changeFields.split(","))
                    //     // console.log(document.querySelectorAll(`.${key}`)[21])
                    //     // document.querySelectorAll(`.${key}`)[contentIdx].style.color = "#eb2b2b";
                    //     // console.log(document.querySelectorAll(`.${key}`)[contentIdx]);
                    // }
                  });
                });
              }
            });
          });
        })
        .catch(err => {
          console.log(err);
          this.searchLoading = false;
        });
    },
    fetchData() {
      this.loading = true;
      this.onload = "100";
      const requestBody = {
        // pagePerCount: this.listQuery.perPageCount,
        pagePerCount: this.listQuery.perPageCount,
        currentPage: this.listQuery.currentPage - 1,
        // currentPagePerCount: 0,
        fromDate: this.listQuery.fromDate,
        toDate: this.listQuery.toDate,
        reqType: this.stateId,
        dateType: 5,
        keywordType: this.keywordId,
        keyword: this.listQuery.keyword,
        vendorNos: this.selectVendorList
      };
      return employeeApi
        .modifiedHistoryV2(requestBody)
        .then(res => {
          // console.log("오더 리스트 api", res)
          const payLoad = res.data.payLoad;
          this.listQuery.currentPage =
            payLoad.totalContentCnt === 0 ? 1 : payLoad.currentPage + 1;
          this.total = payLoad.totalContentCnt;
          this.payload = payLoad.contents;
          this.loading = false;

          this.$nextTick(() => {
            this.payload.forEach((content, contentIdx) => {
              if (content.changeFields) {
                Object.keys(content).forEach(key => {
                  content.changeFields.split(",").forEach(res => {
                    if (
                      key !== "changeFields" &&
                      res.split(".")[0] === key.split(".")[0]
                    ) {
                      // console.log(contentIdx, res);
                      // document.querySelectorAll(`.${res}`)[contentIdx].style.color = "#eb2b2b"
                      // console.log("적용완료", document.querySelectorAll(`.${key}`))
                      const response = res.split(".");

                      let className = null;
                      if (response[1] !== undefined) {
                        className = key + "_" + response[1];
                      } else {
                        className = key;
                      }
                      // console.log(contentIdx ,className)
                      const dom = document.querySelectorAll(`.${className}`);

                      if (dom && dom.length > 0) {
                        dom[contentIdx].style.color = "#eb2b2b";
                      }
                    }
                    // console.log(content.changeFields.split(","))
                    // if(key !== "changeFields" && res === key.split(".")[0]) {
                    //     // console.log(content.changeFields.split(","))
                    //     // console.log(document.querySelectorAll(`.${key}`)[21])

                    //     // document.querySelectorAll(`.${key}`)[contentIdx].style.color = "#eb2b2b";
                    //     // console.log(document.querySelectorAll(`.${key}`)[contentIdx]);
                    // }
                  });
                });
              }
            });
          });
        })
        .catch(err => {
          console.log(err);
          // this.searchLoading = false;
        });
    },

    updateOrder(row, text) {
      console.log(text);
      const requestBody = {
        pid: row.pid,
        orderNo: row.orderNo,
        managerName: this.$store.getters.userAccount.name,
        requestType: 1 // row.comfirmType
      };
      const dataRequestBody = {
        pid: row.pid,
        orderNo: row.orderNo,
        managerName: this.$store.getters.userAccount.name
      };
      // if (row.managerName === null || row.managerName === '' || typeof row.managerName === undefined) {
      if (
        this.$store.getters.userAccount.name === "" ||
        this.$store.getters.userAccount.name === null ||
        typeof this.$store.getters.userAccount.name === undefined
      ) {
        this.$message.error("수정자 이름이 비어있습니다.");
      } else {
        if (text === "주문확인") {
          this.$confirm("주문 확인을 하시겠습니까?", "주문 확인", {
            confirmButtonText: "확인",
            cancelButtonText: "취소",
            type: "warning"
          })
            .then(() => {
              return employeeApi
                .updateModifiedState(requestBody)
                .then(res => {
                  if (res.data.result === 0) {
                    // 클립보드 복사 기능
                    this.$copyText(String(row.orderNo))
                      .then(e => {
                        this.$message.success("주문번호 복사됨");
                      })
                      .catch(err => {
                        alert(err);
                      });
                    this.handleSearch();
                  } else {
                    this.$message.error(res.data.message);
                  }
                })
                .catch(err => {
                  console.log(err);
                });
            })
            .catch(() => {});
        } else if (text === "확인 & 적용") {
          this.$confirm("주문 확인 및 적용하시겠습니까?", "주문 확인 및 적용", {
            confirmButtonText: "확인 및 적용",
            cancelButtonText: "취소",
            type: "warning"
          }).then(() => {
            return employeeApi
              .upDate(dataRequestBody)
              .then(res => {
                if (res.data.result === 0) {
                  // console.log("주문 확인 api", res);
                  return employeeApi
                    .updateModifiedState(requestBody)
                    .then(res => {
                      // 클립보드 복사 기능
                      this.$copyText(String(row.orderNo))
                        .then(e => {
                          this.$message.success("주문번호 복사됨");
                        })
                        .catch(err => {
                          alert(err);
                        });
                      this.handleSearch();
                    })
                    .catch(err => {
                      console.log(err);
                    });
                } else {
                  this.$message.error(res.data.message);
                }
              })
              .catch(err => {
                console.log(err);
              });
          });
        }
      }
    },
    reOrder(row) {
      // console.log(row);
      const requestBody = {
        pid: row.pid,
        vendorNo: row.vendorNo,
        managerName: this.$store.getters.userAccount.name,
        reqType: row.reqType
      };
      if (
        this.$store.getters.userAccount.name === null ||
        this.$store.getters.userAccount.name === "" ||
        typeof this.$store.getters.userAccount.name === undefined
      ) {
        this.$message.error("수정자 이름이 비어있습니다.");
      } else {
        this.loading = true;
        return employeeApi
          .reOrder(requestBody)
          .then(res => {
            this.loading = false;
            // 클립보드 복사 기능
            this.$copyText(String(row.orderNo))
              .then(e => {
                this.$message.success("주문번호 복사됨");
              })
              .catch(err => {
                alert(err);
              });
            console.log("재연동 결과값", res);
            this.handleSearch();
          })
          .catch(err => {
            this.loading = false;
            // this.$message.error(`재연동 문제 발생 (${err})`);
            this.$alert(`재연동 진행 중 문제 발생 </br>(${err})`, "에러", {
              type: "error",
              dangerouslyUseHTMLString: true
            });
            this.handleSearch();
            console.log(err);
          });
        // this.$confirm(`아래의 사유로 문제가 발생되었습니다.<br/>주문 확인 후 재시도 하세요.<br/><br/>${row.orderApplyStateMsg}`, '재연동', {
        //     dangerouslyUseHTMLString: true,
        //     confirmButtonText: '확인',
        //     cancelButtonText: '취소',
        //     type: 'warning'
        // }).then(() => {

        // }).catch(() => {
        // });
      }
    }
  }
};
</script>
<style scoped>
/* el-component */
.reOrderBox {
  min-width: 600px;
}

.main {
  width: 100vw;
  height: auto;
  overflow: hidden;
  display: flex;
}
.left-container {
  /* width: 12vw; */
  width: 200px;
  height: 100vh;
  padding-top: 20px;
  background-color: #699bc9;
  text-align: center;
}
.button-list {
  width: 100%;
  margin-top: 10px;
  display: flex;
  justify-content: center;
  gap: 2px;
}
.title {
  color: #fff;
  font-weight: bold;
  font-size: 40px;
}
.title2 {
  font-size: 13px;
  color: #fff;
}
.user-info {
  padding: 5px 15px;
  text-align: right;
}
.table-option {
  padding: 10px 0;
  padding-left: 10px;
}
.table {
  padding: 10px;
  margin-bottom: 0;
}
.padding span {
  margin-right: 5px;
}
.ExcelAndTotal {
  display: flex;
  justify-content: space-between;
}
.bottom-line {
  border-bottom: 1px solid #666;
}
.padding {
  padding: 4px;
}
.section-width {
  width: 100vw;
}
.corp-select span {
  padding-top: 3px;
}
.option-tab {
  /* display: flex; */
}
.none-margin {
  line-height: 25px;
  width: 100px;
  text-align: right;
  margin-right: 5px;
}
.none-margin1 {
  line-height: 25px;
  width: 70px;
  text-align: right;
  margin-right: 5px;
}

@media (max-width: 1500px) {
  .option-tab {
    display: block;
  }
  .none-margin {
    text-align: left;
    width: 70px;
    margin: 0;
  }
  .padding span {
    margin-right: 5px;
  }
}
/* @keyframes blink-effect {
        50% {
            color: #000;
            background-color: #fff;
        }
    }
     */
@keyframes fadeinout {
  0% {
    color: #000;
    /* background-color: #fff; */
  }
  50% {
    color: #ff0000;
    /* background-color: #eb2b2b; */
  }
  100% {
    color: #000;
    /* background-color: #fff; */
  }
}

/* 스타일 클래스 */
.red {
  color: #eb2b2b;
}
.redEffect {
  /* transition: all 0.5s ease-out; */
  animation-iteration-count: infinite;
  animation-fill-mode: forwards;
  animation-name: fadeinout;
  animation-delay: 0s;
  animation-duration: 1s;

  /*
        animation-name: blink-effect;
        animation-duration: 1s;
        animation-timing-function:step-end;
        */
}
.redEffectOff {
  transition: 0.4s;
  color: #000;
}
</style>



// WEBPACK FOOTER //
// src/components/MonitoringV3.vue